import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Tables from "layouts/tables";
import { useState } from "react";
import { Button } from "@mui/material";
import { useSelector } from "react-redux";
import { hasActionAccess } from "utility";
import { useGetAlertsQuery, useDeleteAlertMutation } from "slices/common/alertSlice";

function Alerts() {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [del] = useDeleteAlertMutation();
  const auth = useSelector((state) => state.auth.auth?.user);

  const { data, isLoading, refetch } = useGetAlertsQuery({
    page,
    limit,
    search,
  });

  const col = [
    {
      display: "Description",
      key: "description",
      type: "display",
      render: (row) => {
        const userName = row?.user_id?.name;     // name inside user_id object
        const desc = row?.description;
        // if description starts with userId → concatenate name + description
        if (userName && desc) {
          return `${userName} ${desc}`;
        }
        return desc; // otherwise show normal description
      },
    },
  ];

  const canEdit = hasActionAccess(auth, "Beauty App", "Services", "edit");
  const canDelete = hasActionAccess(auth, "Beauty App", "Services", "delete");
  if (canEdit || canDelete) {
    col.push({
      display: "Actions",
      key: "edit",
      type: "action",
      render: (row, handleDelete) => (
        <>
          {canDelete && (
            <Button onClick={() => handleDelete(row._id)}>Delete</Button>
          )}
        </>
      ),
    });
  }

  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
  };

  const changePage = (newPage, newLimit) => {
    const apiPage = newPage + 1; // MUI is 0-based, API is 1-based
    setPage(apiPage);
    setLimit(newLimit);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this alert?")) {
      await del(id).unwrap();
      refetch();
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {/* {canAdd && (
        <Button onClick={handleAdd} style={{ background: "#fff" }}>
          Add Item
        </Button>
      )} */}
      
      <Tables
        title={"Alerts"}
        handleSearch={handleSearchChange}
        totalPages={data?.total}
        data={data?.data}
        columns={col}
        changePage={changePage}
        onEdit={""}
        handleDelete={handleDelete}
        currentPage={page} // ✅ pass to control current pagination
        rowsPerPage={limit}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default Alerts;

